import {getMpOpenIdByCodeAPI, wechatOauthTokenAPI, userInfoAPI} from '../modle/login.js';
import jsCookie from 'js-cookie';
import config from '../config.js';
import splitUrlUtil from '../util/splitUrlUtil.js';
import tokenUtil from "@/util/tokenUtil";
import store from "../store";
import {appletAccountTicketAPI} from "@/modle/api";
import { Toast } from 'vant';

export default {
    // 获取openid
    getOpenId(cb) {
        var openId = jsCookie.get("openId");
        // 判断openId 是否存在
        /*if (openId === undefined || openId == 'undefined') {
        }*/
        var query = splitUrlUtil.getUrlParams();
        if (query["code"] !== undefined) {
            /*重新授权 清空缓存信息 start*/
            // store.commit("handleUserInfo", {});
            // store.commit("handleOtherUserInfo", {});
            // store.commit("changeLogin", false);
            /*重新授权 清空缓存信息 end*/
            this.getWeChatOpenId(query["code"]);
        } else {
            this.getWeChatOpenIdCode();
        }
        if (typeof cb === "function") {
            cb();
        }
    },
    // 发送获取 code
    getWeChatOpenIdCode() {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appId + '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_base&state=snsapi_base#wechat_redirect';
    },
    // 发送获取 openId
    async getWeChatOpenId(code) {
        try {
            var result = await getMpOpenIdByCodeAPI({
                authCode: code
            });
            console.log(result);
            if (result.data && result.data.openId) {
                jsCookie.set("wechatOpenId", result.data.openId, {expires: 1000});
                window.localStorage.removeItem('resetLoginNum');
            } else {
                /*const resetLoginNum = window.localStorage.getItem('resetLoginNum') || 0;
                if (resetLoginNum >= 1) {

                } else {
                    window.localStorage.setItem('resetLoginNum', resetLoginNum + 1);
                    const winLocation = window.location;
                    console.log('window', winLocation)
                    const curUrl = `${winLocation.origin}${winLocation.pathname}#/`;
                    console.log('curUrl',curUrl);
                    window.location.href = curUrl;
                    return false
                }*/
            }
            await this.weChatOauthToken((result.data && result.data.openId) || '');
        } catch (error) {
            console.log(error);
        }
    },
    // 登录
    async weChatOauthToken(openId) {
        try {
            let {data, code, message} = await wechatOauthTokenAPI({openId});
            console.log('data, code, message', data, code, message);
            if (Number(code) === 0) {
                tokenUtil.setToken(
                    data.value,
                    data.refreshToken.value || "",
                    data.additionalInformation.ucode,
                    data.tokenType,
                    data.expiresIn
                );
                await this.userInfo();
            }
        } catch (error) {
            console.log(error);
        }
    },
    // 获取个人信息
    async userInfo() {
        try {
            let {data, code, message} = await userInfoAPI();
            console.log('获取个人信息 data, code, message', data, code, message);
            if (Number(code) === 0) {
                store.commit("handleUserInfo", data);
                store.commit("changeLogin", true);
            } else {
                store.commit("handleUserInfo", {});
                store.commit("changeLogin", false);
            }
        } catch (e) {
            throw Error(e)
        }
    },
    // 注册微信 api
    async onRegister(readyShare) {
        try {
            let {data, code, message} = await appletAccountTicketAPI({
                url: window.location.href.split('#')[0],
                appid: config.registerId, //众志成晟
            });
            if (Number(code) === 0) {
                console.log('data--------', data)
                this.registerWXAPI({...data}, readyShare);
            } else {
            }
        } catch (e) {
            throw Error(e)
        }
    },
    // 注册微信 api
    registerWXAPI(params, readyShare) {
        console.log('params--------', params)
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.registerId, // 必填，企业微信的corpID
            timestamp: params.timestamp, // 必填，生成签名的时间戳
            nonceStr: params.nonceStr, // 必填，生成签名的随机串
            signature: params.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
            // jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            jsApiList: [
                'updateAppMessageShareData', //分享给好友
                'updateTimelineShareData'//分享到朋友圈
            ],
        });
        wx.ready(res => {
            console.log('res,ready,:', res)
            const shareData = {
                title: readyShare.title || '', // 分享标题
                desc: readyShare.desc || '', // 分享描述
                link: readyShare.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: readyShare.imgUrl || '', // 分享图标
                success: function () {
                    // 设置成功
                    console.log('成功！！！！')
                }
            };
            console.log('shareData',shareData)
            const timeLineData = {
                title: readyShare.title || '', // 分享标题
                link: readyShare.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: readyShare.imgUrl || '', // 分享图标
                success: function () {
                    // 设置成功
                    console.log('成功！！！！')
                }
            };
            // Toast(shareData);
            wx.checkJsApi({
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                    console.log('checkJsApi----', res)
                    // 以键值对的形式返回，可用的api值true，不可用为false
                    // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                    wx.updateAppMessageShareData(shareData);
                    wx.updateTimelineShareData(timeLineData);
                }
            });

        });
        wx.error((err) => {
            console.log('err:', err);
        })
    },
}



// WEBPACK FOOTER //
// ./src/util/wechatOpenId.js